// AI Generated Test
import { Component, Input } from '@angular/core';

@Component({
    selector: 'page-fix-changeset-custom',
    standalone: false,
    template: `
        <page-fix-changeset-spelling [data]="data"></page-fix-changeset-spelling>
    `,
})
export class PageFixChangesetCustomComponent {
    @Input() data: any;
}
